import type { ElectronContext } from '@mimir/common/context/applicationContext';
import type { LauncherParams } from '../driver-common/launcher-params';
import { startLauncher } from '../driver-common/launcher';
import type { Logger } from '@mimir/common/types/logger';

import { getAmeScriptString } from './script';
import { ameState, type AmeConfig } from './config';
import type { NleAsset } from '@mimir/common/dto/tenantModel';

export const launchStep = (
  applicationContext: ElectronContext,
  launcherParams: LauncherParams,
) => {
  const ameArgs = ['--console', 'es.processFile', launcherParams.tempScriptFilePath];
  console.debug(`Starting new AME process ${launcherParams.encoderExePath} ${ameArgs.join(' ')}`);
  const ameProcess = applicationContext.mainRequire('child_process').execFile(launcherParams.encoderExePath, ameArgs, (error: Error, stdout: string, stderr: string) => {
    console.debug(`error: ${error}`);
    console.debug(`stdout: ${stdout}`);
    console.debug(`stderr: ${stderr}`);
  });
  console.debug(`Started new AME process: ${ameProcess.pid}`);

  return ameProcess;
};

export const launchWithConfig = (
  services: {
    applicationContext: ElectronContext,
    logger: Logger,
    getDownloadPath: () => string,
  },
  ameConfig: AmeConfig,
) => {
  startLauncher(
    services,
    {
      enabled: ameConfig.enabled,
      encoderExePath: ameConfig.amePath,
      selectedWatchFolders: ameConfig.selectedWatchFolders,
      projectFileExtension: '.prproj',
      processName: 'Adobe Media Encoder',
      doesPresetMatch: (presetName: string, preset: NleAsset) => preset.nleType !== 'dvr' && (preset.name === presetName || preset.name === `${presetName}.epr`),
      rendererLaunchStep: launchStep,
      getScriptString: getAmeScriptString,
      scriptFileExtension: 'js',
    },
    ameState,
  );
};

